import { getCalcInputState } from "../../../../../utils/selectors";
import { headerSlice } from "./slice";

export const getHeaderState = state => getCalcInputState(state)[headerSlice.name];